<template>
  <el-row class="menu_page">
    <el-col>
      <!-- <el-menu
        class="el-menu-vertical-demo"
        unique-opened
        router
        background-color="#FFFFFF"
        text-color="#303133"
        active-text-color="#5787FF">
        <el-menu-item index="/">
          <i class="el-icon-menu"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <div v-for="(menu, index) in menus" :key="index">
          <el-menu-item v-if="menu.cate === 0" :index="menu.client_route">
            <i :class="menu.icon"></i>
            <span slot="title">{{menu.menu_name}}</span>
          </el-menu-item>
          <el-submenu v-else :index="menu.cate">
            <template slot="title">
              <i class="el-icon-tickets"></i>
              <span>{{menu.cate}}</span>
            </template>
            <el-menu-item v-for="(menuChild, idx) in menu.child" :key="idx" :index="menuChild.client_route">{{menuChild.menu_name}}</el-menu-item>
          </el-submenu>
        </div>
      </el-menu> -->
      <div class="search-input" v-if="showOrhide">
        <el-select
          v-model="menuterm"
          filterable
          remote
          reserve-keyword
          placeholder="请输入名称搜索"
          size="mini"
          clearable
          :remote-method="searchRemoteMenuTerm"
          :loading="searchLoading"
          @change="handleSearchChange"
        >
          <el-option
            v-for="item in menuObj"
            :key="item.id"
            :label="item.menu_name"
            :value="item.client_route"
          >
          </el-option>
        </el-select>
      </div>
      <el-menu class="el-menu-vertical-demo" :unique-opened="true" router background-color="#FFFFFF"
        :collapse="isCollapse" text-color="#303133" active-text-color="#5787FF" :width="isCollapse ? '64px' : '180px'"
        @select="handleClickMenuItem" :default-active="activeIndex">
        <el-menu-item @click="toggleCollapse">
          <i :class="isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
          <span slot="title">展开/折叠</span>
        </el-menu-item>
        <!-- <el-menu-item index="/">
          <i class="el-icon-menu"></i>
          <span slot="title">首页</span>
        </el-menu-item> -->
        <template v-for="(menu, index) in menus">
          <el-submenu :index="menu.cate">
            <template slot="title">
              <i :class="menu.icon[0]"></i>
              <span slot="title">{{ menu.cate }}</span>
            </template>
            <el-menu-item v-for="(menuChild, idx) in menu.child" :key="idx" :index="`/${menuChild.client_route}`">
              <span slot="title">{{ menuChild.menu_name }}</span>
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'LeftMenu',
  props: {
    user: Object,
    menus: Array
  },
  data() {
    return {
      // isCollapse: true,
      activeIndex: '/',
      menuData: [],
      admin: ['张六六', '常延龙', '李艳晴', '吕文飞', '李路路', '何涛', '沈阳', '杨宇璇', '毛宇明', '唐立阳'],
      admin2: ['张六六', '常延龙', '李路路', '杨宇璇', '毛宇明', '唐立阳'],
      searchLoading: false,
      menuObj: [],
      showOrhide: true,
      menuterm: ''
    }
  },
  watch: {
    // '$route' () {
    //   this.activeIndex = sessionStorage.getItem('keyPath') || '/'
    // }
    // activeIndex (newValue) {
    //   if (newValue != this.$route.path) {
    //   	this.activeIndex = this.$route.path
    //   }
    //   // 如果使用 v-for 循环 可以取消上面注释
    //   console.log('new' + newValue);
    // }
  },
  computed: {
    isCollapse: {
      get() {
        return this.$store.state.collapse;
      },
      set(value) {
        this.$store.commit('setCollapse', value)
      }
    }
  },
  methods: {
    searchRemoteMenuTerm(query) {
      this.menuterm = query
      if (this.menuterm !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItem(this.menuterm);
        }, 200);
      } else {
        this.menuObj = [];
      }
    },
    searchItem() {
      this.$axios.get("/api/admin/searchMenuTerm?menu_name=" + this.menuterm).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.menuObj = data.data.terms;
        }
      });
    },
    handleSearchChange(val) {
      if (val === '') {
        return;   // 不做处理
      }
      this.$router.push({path: `/${val}`});
      this.activeIndex = this.$route.path.substring(1)
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
      this.showOrhide = !this.showOrhide
      // 保存当前展开/折叠状态
      this.$axios.post('/api/admin/save_open_or_close', { state: this.isCollapse })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$store.dispatch('setCollapse', this.isCollapse)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleClickMenuItem(index) {
      // console.log('index', index)
      let menu = this.menus.flatMap(item => item.child).filter(childItem => childItem.client_route === index)
      if (menu && menu.length === 1) {
        let routes = this.$router.options.routes[1].children
        let item = routes.find(item => item.path === index)

        menu[0].component = item.component
        this.$set(menu[0], 'zIndex', 3000)
        this.$set(menu[0], 'winVisible', false)
        this.$store.dispatch('createWindowHostStoreAction', menu[0])
      }



      // 查看是否已经存在
      // let foundIndex = this.$store.state.windowHostStore.findIndex(item => item.client_route === index)
      // if (foundIndex !== -1) return

      // let menu = this.menus.flatMap(item => item.child).filter(childItem => childItem.client_route === index)
      // if (menu && menu.length === 1) {
      //   let routes = this.$router.options.routes[1].children
      //   let item = routes.find(item => item.path === index)

      //   menu[0].component = item.component
      //   this.$set(menu[0], 'winVisible', false)
      //   this.$store.dispatch('createWindowHostStoreAction', menu[0])
      // }
      sessionStorage.setItem('keyPath', index)
    }
  },
  created () {
    this.activeIndex = this.$route.path === '/' ? this.$route.path : this.$route.path.substring(1)
  },
  mounted() {
		// this.activeIndex = sessionStorage.getItem('keyPath') || '/'
    // this.activeIndex = 'vip_orders'
    // alert(sessionStorage.getItem('keyPath'))
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .menu_page
    position: fixed
    top: $mt
    bottom: 0
    left: 0
    background-color: #FFFFFF
    border: solid 1px #e6e6e6
    box-shadow: 4px 0px 15px 0px rgba(134, 134, 134, 0.13)
    z-index: 99
    overflow-y: auto
  .el-menu
    border: none
  .el-menu-vertical-demo:not(.el-menu--collapse)
    width: 180px
    min-height: 400px
  .el-submenu .el-menu-item
    min-width: 180px
  .search-input
    width: 180px
    height: 50px
    padding-top: 20px
  .el-select >>> .el-input__inner
    width: 180px
    padding: 20px 0 !important
    border: 1px solid #4d84fe
</style>



// WEBPACK FOOTER //
// src/common/LeftMenu.vue